import React, {PureComponent} from 'react';
import Select from 'react-select';

class SelectField extends PureComponent {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    value: 0
  }

  componentDidMount() {
    this.setState({ value: this.props.defaultValue })
  }

  handleChange = (selectedOption) => {
    this.setState({ value: selectedOption })
    this.props.onChange(selectedOption);
  };

  render() {
    const {name} = this.props;

    return (
      <Select
        style={{
          borderColor: this.props.borderColor
        }}
        name={name}
        value={this.state.value}
        onChange={this.handleChange}
        options={this.props.options}
        className={this.props.borderColor ? 'form__form-group-select select-errors' : 'form__form-group-select'}
        placeholder={this.props.placeholder}
        clearable={this.props.clearable}
      />
    )
  }
}

const renderSelectField = (props) => {
  return <div className='form__form-group-input-wrap'>
    <SelectField
      {...props.input}
      options={props.options}
      defaultValue={props.defaultValue}
      clearable={props.clearable}
      onChange={props.onChange}
      value={props.value}
      borderColor={props.borderColor}
    />
    
  </div>
};

// renderSelectField.propTypes = {
//   input: PropTypes.object.isRequired,
//   meta: PropTypes.object,
//   options: PropTypes.array
// };

export default renderSelectField;



// WEBPACK FOOTER //
// ./src/utils/select.js